import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IMAGES } from "../../assets";
import AppButton from "../../components/button/AppButton";
import About from "./tabs/About";
import Details from "./tabs/Details";
import Reviews from "./tabs/Reviews";
import { useTranslation } from "react-i18next";
import { EbookInfo, updateBookPdfProgress } from "../../api";
import Slider from "react-slick";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import { FILE_URL } from "../../constants/Constants";
import PropTypes from "prop-types";
import { STORAGE_KEY, STRINGS } from "../../constants";
import { AuthContext } from "../../context";
import { Document } from "react-pdf";
import { Modal } from "antd";

const BookDetails = () => {
  const [activeTab, setActiveTab] = useState("About");
  const [showLimitExceedPopup, setShowLimitExceedPopup] = useState(false);
  const [bookReadingPercent, setBookReadingPercent] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  let selectedBookInfo = location?.state?.item ?? null;
  const [bookInfo, setBookInfo] = useState();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    getBookInfo();
  }, [location?.state?.item?._id]);

  useEffect(() => {
    if (numPages > 0) {
      const updateProgress = async () => {
        const params = {
          userId: user?.userInfo?._id,
          bookId: bookInfo?._id,
          totalPages: numPages,
          readPages: pageNumber,
          bookProgress: false,
          instituteId: user?.userInfo?.createdBy,
        };

        try {
          const result = await updateBookPdfProgress(params);
        } catch (err) {
          console.error(err);
        }
      };

      updateProgress();
    }
  }, [numPages]);

  async function getBookInfo() {
    try {
      const result = await EbookInfo(location?.state?.item?._id);
      setBookInfo(result?.data?.body[0]);
    } catch (err) {
      console.error(err);
    }
  }

  const NextArrow = ({ onClick }) => {
    NextArrow.propTypes = { onClick: PropTypes.node };
    return (
      <button
        className="text-[#480D9B] ml-3 flex items-center justify-center p-1 border rounded-full"
        onClick={onClick}
      >
        <CaretRightOutlined className="" />
      </button>
    );
  };
  const PrevArrow = ({ onClick }) => {
    PrevArrow.propTypes = { onClick: PropTypes.node };

    return (
      <button
        className="text-[#480D9B] mr-3 flex items-center justify-center p-1 border rounded-full"
        onClick={onClick}
      >
        <CaretLeftOutlined className="" />
      </button>
    );
  };

  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    cssEase: "linear",
    nextArrow: Array.isArray(bookInfo?.bookImage) &&
      bookInfo?.bookImage?.length > 1 && <NextArrow />,
    prevArrow: Array.isArray(bookInfo?.bookImage) &&
      bookInfo?.bookImage?.length > 1 && <PrevArrow />,
  };
  const handleReadBook = async (close, popupclose) => {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookInfo?._id,
      totalPages: numPages,
      readPages: pageNumber,
      bookProgress: close ?? true,
      instituteId: user?.userInfo?.createdBy,
    };

    try {
      const result = await updateBookPdfProgress(params);
      if (result?.status) {
        // setShowLimitExceedPopup(false);
        // if (!popupclose) {
        navigate(`/readbook/${bookInfo?.bookName}`, {
          state: { bookPdfItem: bookInfo },
        });
        // }
      } else if (
        result?.error ===
        "Access limit exceeded. Please purchase the book license."
      ) {
        setShowLimitExceedPopup(true);
      } else {
        navigate("/");
        localStorage.clear();
      }
    } catch (error) {
      console.error("API request failed:", error);
      setShowLimitExceedPopup(true);
    }
  };
  const handleImpressiveReadBook = async (close, popupclose) => {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookInfo?._id,
      totalPages: numPages,
      readPages: pageNumber,
      bookProgress: close ?? true,
      instituteId: user?.userInfo?.createdBy,
    };

    try {
      const result = await updateBookPdfProgress(params);
      if (result?.status) {
        // setShowLimitExceedPopup(false);
        // if (!popupclose) {
        navigate(`/impresiveread/${bookInfo?.bookName}`, {
          state: { bookPdfItem: bookInfo },
        });
        // }
      } else if (
        result?.error ===
        "Access limit exceeded. Please purchase the book license."
      ) {
        setShowLimitExceedPopup(true);
      } else {
        navigate("/");
        localStorage.clear();
      }
    } catch (error) {
      console.error("API request failed:", error);
      setShowLimitExceedPopup(true);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    getAndSetlocalPageItem();
  }, [numPages]);

  async function getAndSetlocalPageItem() {
    // Calculate the current page number based on reading percentage and total pages
    const currentPageNumber = Math.ceil((bookReadingPercent / 100) * numPages);
    setPageNumber(currentPageNumber === 0 ? 1 : currentPageNumber);

    // Retrieve the stored page number from local storage
    let res = localStorage.getItem(STORAGE_KEY.BOOK_PAGE_NUMBER);

    if (res) {
      // Parse the stored data
      res = JSON.parse(res);

      // Check if the book's ID exists in the stored data
      if (res[bookInfo?._id]) {
        // Split the stored value to get individual page numbers
        let pages = res[bookInfo?._id].split(" ");

        // If there are stored pages, set the last page number to the last one in the array
        if (pages.length > 0) {
          const lastPageNumber = Number(pages[pages.length - 1]);
        }
      }
    }
  }
  return (
    <>
      {/* {showLimitExceedPopup && (
        <div className="limit-exceed-popup min-h-96 h-full w-full ">
          <div className="popup-div">
            <p>{t(STRINGS?.limit_exceeds)}</p>
            <div className="navigate-div">
              <button
                className="px-4 py-2 border-slate-400 border rounded-full cancel-btn"
                onClick={
                  () => setShowLimitExceedPopup(false)
                }
              >
                Cancel
              </button>
             
            </div>
          </div>
        </div>
      )} */}

      <div className="bg-white border p-4 rounded-2xl">
        <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 grid-cols-1 divide-x">
          <div>
            <div className="my-4 flex items-center justify-between">
              <button
                className="w-8 h-8 text-lg font-bold border-slate-400 border flex items-center justify-center rounded-full"
                onClick={() => navigate(-1)}
              >
                <img
                  className="w-full h-full"
                  alt="backarrow"
                  src={IMAGES?.backIcon}
                />
              </button>
            </div>

            <div className="w-full p-4 flex flex-col items-center justify-center gap-3">
              <div className="h-72 w-64 ">
                <Slider
                  arrows={true}
                  style={{
                    display: bookInfo?.bookImage?.length > 1 ? "flex" : "block",
                  }}
                  className={`"flex items-center justify-center ${
                    Array.isArray(bookInfo?.bookImage) &&
                    bookInfo?.bookImage?.length > 1
                      ? "slider-book"
                      : ""
                  } `}
                  {...settings}
                >
                  {Array.isArray(bookInfo?.bookImage) &&
                    bookInfo?.bookImage?.length > 1 &&
                    bookInfo?.bookImage?.map((ele) => (
                      <img
                        key={ele}
                        className="h-64 w-48 object-cover border-2  rounded-xl"
                        src={ele ? `${FILE_URL}${ele}` : IMAGES?.logo}
                        alt="book cover"
                      />
                    ))}
                </Slider>

                {Array.isArray(bookInfo?.bookImage) &&
                  bookInfo?.bookImage?.length === 1 &&
                  bookInfo?.bookImage?.map((ele) => (
                    <img
                      key={ele}
                      className="h-full w-full object-cover rounded-xl"
                      src={ele ? `${FILE_URL}${ele}` : IMAGES?.logo}
                      alt="book cover"
                    />
                  ))}

                {typeof bookInfo?.bookImage === "string" && (
                  <img
                    className="h-full w-full object-cover rounded-xl"
                    src={
                      bookInfo?.bookImage
                        ? `${FILE_URL}${bookInfo?.bookImage}`
                        : IMAGES?.logo
                    }
                    alt="book cover"
                  />
                )}
              </div>
              <div>
                <h2 className="text-lg font-bold text-center">
                  {bookInfo?.bookName}
                </h2>
                <p className="text-sm font-medium text-center">
                  {bookInfo?.authorName}
                </p>
              </div>
            </div>
          </div>
          <div className="pl-6 col-span-2">
            <div className="flex flex-col items-center divide-y w-full gap-2 relative">
              <div className="w-full">
                <div className="my-4 flex items-center justify-between w-full">
                  <div className="flex items-center border rounded-md divide-x">
                    <button
                      onClick={() => setActiveTab("About")}
                      className={`${
                        activeTab === "About"
                          ? "bg-[#480D9B] text-white"
                          : "text-[#B0B0B0] "
                      } text-sm font-medium px-8 py-2 rounded-l-md`}
                    >
                      {t(STRINGS?.about)}
                    </button>

                    <button
                      onClick={() => setActiveTab("Details")}
                      className={`${
                        activeTab === "Details"
                          ? "bg-[#480D9B] text-white"
                          : "text-[#B0B0B0] "
                      } text-sm font-medium px-8 py-2  `}
                    >
                      {t(STRINGS?.details)}
                    </button>
                    <button
                      onClick={() => setActiveTab("Reviews")}
                      className={`${
                        activeTab === "Reviews"
                          ? "bg-[#480D9B] text-white"
                          : "text-[#B0B0B0] "
                      } text-sm font-medium px-8 py-2 rounded-r-md`}
                    >
                      {t(STRINGS?.reviews)}
                    </button>
                  </div>
                  <div></div>
                </div>

                {activeTab === "About" && <About data={bookInfo} />}
                {activeTab === "Details" && <Details data={bookInfo} />}
                {activeTab === "Reviews" && <Reviews data={bookInfo} />}
              </div>
              <div className="w-full flex items-center justify-center mx-10">
                {/* <Link
                  to={`https://api.elibrary.pustakvari.com/uploads/${bookInfo?.bookPdf}`}
                  target="_blank"
                >
                  Download Pdf
                </Link> */}
                {numPages > 0 && (
                  <div className="flex w-full lg:mx-32 md:mx-28 sm:mx-8 mx-8 gap-2">
                    <AppButton
                      onClick={() => handleReadBook()}
                      btnText={t(STRINGS.read_now)}
                      disabled={false}
                      className="bg-[#FE6B01] text-white w-full py-3 px-8 mt-4 rounded-full  text-base font-medium"
                      btnType={"button"}
                    />
                    {bookInfo?.bookPdfImage?.length > 0 && (
                      <AppButton
                        onClick={() => handleImpressiveReadBook()}
                        btnText={t(STRINGS.impresive_read)}
                        disabled={false}
                        className="bg-[#FE6B01] text-white w-full py-3 px-8 mt-4 rounded-full  text-base font-medium"
                        btnType={"button"}
                      />
                    )}
                  </div>
                )}
                <div className="hidden">
                  <Document
                    file={`${FILE_URL}${bookInfo?.bookPdf}`}
                    onLoadSuccess={onDocumentLoadSuccess}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        width={400}
        open={showLimitExceedPopup}
        onOk={() => setShowLimitExceedPopup(false)}
        onCancel={() => setShowLimitExceedPopup(false)}
        // destroyOnClose
        centered
        footer={null}
        closeIcon={false}
      >
        <div className="popup-div">
          <p className="text-base font-medium">{t(STRINGS?.limit_exceeds)}</p>
          <div className="navigate-div flex items-center justify-center mt-2">
            <button
              className="px-4 py-2 border-slate-400 border rounded-full cancel-btn text-center"
              onClick={() => setShowLimitExceedPopup(false)}
            >
              {t(STRINGS?.cancel)}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BookDetails;
